import { createIcon } from "@chakra-ui/icons";

export default createIcon({
  displayName: "Circle",
  viewBox: "0 0 512 512",
  path: (
    <path
      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
      fill="currentColor"
    />
  ),
});
